import { render, staticRenderFns } from "./EditExtruder.vue?vue&type=template&id=8cb74e20&scoped=true"
import script from "./EditExtruder.vue?vue&type=script&lang=js"
export * from "./EditExtruder.vue?vue&type=script&lang=js"
import style0 from "./EditExtruder.vue?vue&type=style&index=0&id=8cb74e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb74e20",
  null
  
)

export default component.exports